/**
 * These are the different categories for discounts and loadings
 */

export const DiscountCategoriesJSON = Object.freeze({
  REBATE_DISCOUNT: 'rebateDiscount',
  DVA_DISCOUNT: 'dvaDiscount',
  LHC_SURCHARGE: 'lhcSurcharge',
  ABD_DISCOUNT: 'abdDiscount',
  ADF_DISCOUNT: 'adfDiscount',
  RESERVIST_DISCOUNT: 'reservistDiscount',
  TRANSITION_DISCOUNT: 'transitionDiscount',
  VETERAN_DISCOUNT: 'veteranDiscount',
});

export const DiscountCategories = Object.freeze({
  REBATE: 'Australian Government Rebate',
  DVA_DISCOUNT: 'DVA discount',
  LHC_LOADING: 'Lifetime Health Cover (LHC)',
  ABD_DISCOUNT: 'Age-based discount',
  ADF_DISCOUNT: 'ADF discount',
  RESERVIST_DISCOUNT: 'Reservist discount',
  TRANSITION_DISCOUNT: 'Transition discount',
  VETERAN_DISCOUNT: 'Veteran discount',
});

export const DiscountsList = [
  DiscountCategoriesJSON.REBATE_DISCOUNT,
  DiscountCategoriesJSON.DVA_DISCOUNT,
  DiscountCategoriesJSON.ABD_DISCOUNT,
  DiscountCategoriesJSON.ADF_DISCOUNT,
  DiscountCategoriesJSON.RESERVIST_DISCOUNT,
  DiscountCategoriesJSON.TRANSITION_DISCOUNT,
  DiscountCategoriesJSON.VETERAN_DISCOUNT,
];

export const LoadingsList = [DiscountCategoriesJSON.LHC_SURCHARGE];
